import React from "react";
import { Link } from "react-router-dom";
import { Globe, MapPin, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10 pt-20 pb-10">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          
          {/* Column 1: Corporate */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-[0.2em] mb-8 text-sm border-b border-white/10 pb-2 inline-block">Corporate</h4>
            <ul className="space-y-4 text-sm text-gray-400">
              <li><Link to="/our-story" className="hover:text-dreibach-teal transition-colors">About Dreibach</Link></li>
              <li><Link to="/careers" className="hover:text-dreibach-teal transition-colors">Careers</Link></li>
              <li><Link to="/products" className="hover:text-dreibach-teal transition-colors">Product Catalogue</Link></li>
              <li><Link to="/press" className="hover:text-dreibach-teal transition-colors">Press & News</Link></li>
            </ul>
          </div>

          {/* Column 2: Infrastructure - HIDDEN */}
          {/* <div>
            <h4 className="text-white font-bold uppercase tracking-[0.2em] mb-8 text-sm border-b border-white/10 pb-2 inline-block">Infrastructure</h4>
            <ul className="space-y-4 text-sm text-gray-400">
              <li><Link to="/infrastructure" className="hover:text-dreibach-teal transition-colors">Northampton Super-Hub</Link></li>
              <li><Link to="/infrastructure" className="hover:text-dreibach-teal transition-colors">Global Logistics</Link></li>
              <li><Link to="/infrastructure" className="hover:text-dreibach-teal transition-colors">Technology Stack</Link></li>
            </ul>
          </div> */}

          {/* Column 3: Legal & Support */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-[0.2em] mb-8 text-sm border-b border-white/10 pb-2 inline-block">Legal & Support</h4>
            <ul className="space-y-4 text-sm text-gray-400">
              <li><Link to="/privacy" className="hover:text-dreibach-teal transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-dreibach-teal transition-colors">Terms of Service</Link></li>
              <li><Link to="/slavery-statement" className="hover:text-dreibach-teal transition-colors">Modern Slavery Statement</Link></li>
              <li><Link to="/contact" className="hover:text-dreibach-teal transition-colors">Contact Support</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-gray-600 uppercase tracking-wider font-medium">
          <p>© 2026 Dreibach Ltd. All Rights Reserved.</p>
          <div className="flex flex-col md:flex-row gap-2 md:gap-8 md:items-center">
             <span>Registered Office: Unit 2, Capital Business Park, Manor Way, Borehamwood, WD6 1GW</span>
             <span>Company Reg: 11302910</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
